<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span v-else class="border-l-3 border-color-primary pl-10px text-18px">{{
          pageType === 'create' ? '新增' : '编辑'
        }}</span>
      </div>
    </div>
    <div
      v-loading="pageLoading"
      class="w-full overflow-y-auto overflow-x-hidden pr-40px"
      :class="[pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form
        ref="form"
        label-width="140px"
        :rules="rules"
        :model="formData"
        :disabled="['read'].includes(pageType)"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examName"
              label="考试名称"
              prop="examName"
              :rules="[
                {
                  required: true,
                  message: `请输入`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input
                v-model="formData.examName"
                placeholder="请输入试卷名称"
                maxlength="20"
                show-word-limit
                clearable
                :disabled="['read'].includes(pageType)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="考试编号" prop="examCode" ref="examCode">
              <el-input
                v-model="formData.examCode"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examCategory"
              label="考试类型"
              prop="examCategory"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.examCategory"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="['read'].includes(pageType)"
              >
                <el-option
                  v-for="item in pagerTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="dateArr"
              label="考试时间"
              prop="dateArr"
              :rules="[
                {
                  required: true,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-date-picker
                class="w-full"
                style="width:100%"
                v-model="formData.dateArr"
                type="datetimerange"
                size="small"
                range-separator="-"
                :start-placeholder="`${$t('开始日期')}`"
                :end-placeholder="`${$t('结束日期')}`"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              label="是否任意时间参加"
              prop="isAnyTime"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.isAnyTime"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="['read'].includes(pageType)"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examTotalScore"
              label="考试总分"
              prop="examTotalScore"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input v-model.number="formData.examTotalScore" disabled />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="积分" prop="integral" ref="integral">
              <el-input
                maxlength="10"
                show-word-limit
                :placeholder="'请输入'"
                v-model.number="formData.integral"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="sponsor" label="发起人" prop="sponsor">
              <MultiplePersonSelect
                :disabled="['read'].includes(pageType)"
                class="w-full"
                placeholder="请输入"
                v-model="formData.sponsor"
              ></MultiplePersonSelect>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试公告" prop="examNotice" ref="examNotice">
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="formData.examNotice"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="考试场次"
          :rules="[
            {
              required: true,
              message: `请选择`,
              trigger: ['change', 'blur'],
            },
          ]"
        >
        </el-form-item>
        <el-row class="pl-80px">
          <el-col :span="24">
            <el-table
              :data="formData.examSessions"
              border
              class="w-full mb-20px detail_table"
              stripe
              :height="tableHeight"
              row-key="id"
            >
              <el-table-column label="考试场次" type="index" width="100"></el-table-column>
              <el-table-column label="采用试卷" prop="usingExamPaper" min-width="200">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  采用试卷
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.usingExamPaper`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.usingExamPaper`"
                    :rules="[
                      {
                        required: true,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultipleExamSelect
                      :disabled="['read'].includes(pageType)"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.usingExamPaper"
                    ></MultipleExamSelect>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="场次名称" prop="examSessionName" width="200">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  场次名称
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examSessionName`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examSessionName`"
                    :rules="[
                      {
                        required: true,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.examSessionName"
                      class="absoulate"
                    >
                      <!-- <el-input
                        maxlength="20"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model="scope.row.examSessionName"
                        clearable
                      ></el-input> -->
                      <el-input
                        maxlength="20"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model="scope.row.examSessionName"
                        clearable
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="建议考试时长(分钟)"
                prop="suggestedExamDuration"
                show-overflow-tooltip
                width="160"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  建议考试时长(分钟)
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.suggestedExamDuration`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.suggestedExamDuration`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input
                      maxlength="5"
                      show-word-limit
                      :placeholder="'请输入'"
                      v-model.number="scope.row.suggestedExamDuration"
                      clearable
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <template v-if="formData.isAnyTime === false">
                <el-table-column
                  label="单次考试时间"
                  prop="tableDateArr"
                  show-overflow-tooltip
                  width="380"
                >
                  <template slot="header">
                    <span class="text-red-500">*</span>
                    单次考试时间
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :ref="`examSessions.${scope.$index}.tableDateArr`"
                      class="mt-20px"
                      label=""
                      label-width="0"
                      :prop="`examSessions.${scope.$index}.tableDateArr`"
                      :rules="[
                        {
                          required: true,
                          trigger: ['change', 'blur'],
                        },
                      ]"
                    >
                      <el-date-picker
                        class="w-full"
                        style="width:100%"
                        v-model="scope.row.tableDateArr"
                        type="datetimerange"
                        size="small"
                        range-separator="-"
                        :start-placeholder="`${$t('开始日期')}`"
                        :end-placeholder="`${$t('结束日期')}`"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="(dateList) => tableDateChange(dateList, scope.row)"
                        :picker-options="pickerOptions"
                        clearable
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="考试时长(分钟)"
                  prop="examDuration"
                  show-overflow-tooltip
                  width="160"
                >
                  <template slot="header">
                    <span class="text-red-500">*</span>
                    考试时长(分钟)
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :ref="`examSessions.${scope.$index}.examDuration`"
                      class="mt-20px"
                      label=""
                      label-width="0"
                      :prop="`examSessions.${scope.$index}.examDuration`"
                      :rules="[
                        {
                          required: true,
                          message: '请输入',
                          trigger: ['change', 'blur'],
                        },
                      ]"
                    >
                      <el-input
                        maxlength="5"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.examDuration"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </template>
              <el-table-column
                label="单次考试时长(分钟)"
                prop="examDuration"
                show-overflow-tooltip
                width="160"
                v-else
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  单次考试时长(分钟)
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examDuration`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examDuration`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.examDuration"
                      class="absoulate"
                    >
                      <el-input
                        maxlength="5"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.examDuration"
                        clearable
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                label="及格分数"
                prop="passingMark"
                show-overflow-tooltip
                width="100"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  及格分数
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.passingMark`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.passingMark`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.passingMark"
                      class="absoulate"
                    >
                      <el-input
                        maxlength="5"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.passingMark"
                        clearable
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="是否随机组卷"
                prop="randomlyExamPaper"
                show-overflow-tooltip
                width="120"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  是否随机组卷
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.randomlyExamPaper`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.randomlyExamPaper`"
                    :rules="[
                      {
                        required: true,
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="scope.row.randomlyExamPaper"
                      class="w-full"
                      placeholder="请输入"
                      clearable
                    >
                      <el-option
                        v-for="item in changeTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column label="考生" prop="examinee" min-width="220">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  考生
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examinee`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examinee`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultiplePersonSelect
                      :disabled="['read'].includes(pageType)"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.examinee"
                    ></MultiplePersonSelect>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="监考人"
                prop="invigilator"
                show-overflow-tooltip
                width="200px"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  监考人
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.invigilator`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.invigilator`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultiplePersonSelect
                      :disabled="['read'].includes(pageType)"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.invigilator"
                    ></MultiplePersonSelect>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column label="判卷人" prop="judge" min-width="200px">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  判卷人
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.judge`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.judge`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultiplePersonSelect
                      :disabled="['read'].includes(pageType)"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.judge"
                    ></MultiplePersonSelect>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full flex justify-center items-center mt-5 mb-5" v-if="pageType !== 'read'">
      <el-button
        type="primary"
        size="small"
        @click="submitForm('submit')"
        :loading="saveLoading"
        :disabled="pageLoading"
        >保存</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
  </el-card>
</template>

<script>
import { ExamPlanApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'
import MultipleExamSelect from '../MultipleExamSelect'
import { typeList } from '../EnumField'

const examPlanApi = new ExamPlanApi()

export default {
  name: 'question-task-form',
  components: {
    MultiplePersonSelect,
    MultipleExamSelect,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    pageType: {
      type: String,
      default: 'create',
    },
    operateData: {
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
      changeTypeList: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
      testText: '测试',
      // 当前索引值
      curParentIndex: null,
      // 当前选择关联试题的类型, 默认单选题
      curExamType: 0,
      tableLoading: false,
      // 关联题源
      pageLoading: false,
      pagerTypeList: [],
      typeList,
      // 风险点
      pointProps: {
        visible: false,
      },
      pointDialog: false,
      saveLoading: false,
      formData: {
        examName: '',
        examCode: '',
        examCategory: '',
        sponsor: '',
        examTotalScore: 0,
        integral: '',
        examNotice: '',
        dateArr: [],
        examSessions: [],
      },
      rules: {},
    }
  },
  computed: {
    tableHeight() {
      return this.pageType === 'read' ? 'calc(100vh - 400px)' : 'calc(100vh - 450px)'
    },
  },
  watch: {},
  methods: {
    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await examPlanApi.get(this.operateData.examPlanId)
      if (!err) {
        if (res.examStartTime && res.examEndTime) {
          res.dateArr = [new Date(res.examStartTime), new Date(res.examEndTime)]
        }
        if (!res.examSessions) {
          res.examSessions = []
        }
        const data = res.examSessions.map((item) => {
          if (item.singleExamStartTime && item.singleExamEndTime) {
            item.tableDateArr = [
              new Date(item.singleExamStartTime),
              new Date(item.singleExamEndTime),
            ]
          }
          return item
        })
        this.formData = { ...res, examSessions: data }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
      this.pageLoading = false
    },
  },
  created() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
  },
  mounted() {
    if (this.pageType !== 'create') {
      this.getDetail()
    } else {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      this.formData.sponsor = sub
    }
  },
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
::v-deep.detail_table {
  .el-input-group__append {
    display: none;
  }
  .el-input__icon {
    display: none;
  }
  input {
    border: 0;
    background: transparent !important;
  }
  .el-date-editor {
    border: 0;
    background: transparent;
  }
  .el-range-separator {
    background: transparent;
  }
  input[disabled] {
    color: var(--titleTextColor);
    padding: 0 !important;
  }
  .el-form-item {
    margin: 0 !important;
  }
}
</style>
